module.exports = __webpack_public_path__ + "static/img/img_0725.71f3d2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0725.jpg
// module id = dSLt
// module chunks = 0